import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAiIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 11 11",
	xmlns: "http://www.w3.org/2000/svg",
	fill: "#DAD9EF",
	stroke: "#7284FA",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M5.4873 1.13965C5.96381 3.14409 7.52778 4.70806 9.53223 5.18457L10.1719 5.33594L9.53223 5.4873C7.52778 5.96381 5.96381 7.52778 5.4873 9.53223L5.33594 10.1719L5.18457 9.53223C4.70806 7.52778 3.14409 5.96381 1.13965 5.4873L0.5 5.33594L1.13965 5.18457C3.14409 4.70806 4.70806 3.14409 5.18457 1.13965L5.33594 0.5L5.4873 1.13965Z" })
});
export default SvgAiIcon;
